import { animatedRouteTransitionConfig } from '@components/AnimatedRoute'
import { Stack } from '@mui/material'
import { AnimatePresence, motion } from 'framer-motion'
import React, { FC, ReactNode } from 'react'

interface PromptProps {
  show: boolean
  children?: ReactNode
  close?: () => void
}

const Prompt: FC<PromptProps> = ({ show, children, close }) => {
  const emphasizedShort = animatedRouteTransitionConfig['emphasizedShort']
  const deceleratedShort = animatedRouteTransitionConfig['deceleratedShort']

  return (
    <AnimatePresence>
      {show && (
        <Stack
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="fixed"
          borderRadius={3}
          component={motion.div}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={emphasizedShort}
          bgcolor="rgba(0,0,0,0.3)"
          style={{
            backdropFilter: 'blur(5px)',
          }}
          onClick={close}
          zIndex={2}
        >
          <Stack justifyContent="center" flex={1}>
            <Stack
              component={motion.div}
              initial={{ opacity: 0, scale: 1.1 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0 }}
              transition={deceleratedShort}
              bgcolor={(theme) => theme.palette.background.paper}
              mx={4}
              p={2}
              borderRadius={2}
              onClick={(e) => e.stopPropagation()}
            >
              {children}
            </Stack>
          </Stack>
        </Stack>
      )}
    </AnimatePresence>
  )
}

export default Prompt
